import React, { Component } from "react";
import Header from "../Layout/Header/Header";
import Footer from "../Layout/Footer/Footer";
import winner from "../../Assets/img/winner.svg";
import feed_backimg_left from "../../Assets/img/feeback_left.svg";
import feed_backimg_right from "../../Assets/img/feedback_right.svg";
import LevelFeedback from "../Components/Feedback/LevelFeedback";
import { authenticate, make_request, get_current_level } from "../Utils/Utils";

class Winner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edition: null,
      feedback: "",
      api_error: false,
      api_response: ""
    };
  }

  fetch_request = async () => {
    let responseJson = null;
    responseJson = await make_request({
      path: `editions/${this.props.match.params.edition_id}/winner`,
      method: "GET",
    });
    if (responseJson && responseJson.status == "success") {
      this.setState({ edition: responseJson["edition"]});
    } else {
      return window.location = "/not-found";
    }
  };

  async componentDidMount() {
    if (authenticate()) {
      this.fetch_request();
    } else {
      this.props.history.push("/login");
    }
  }

  handle_change = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  onSubmit = async () =>{
    let responseJson = await make_request({
      path: 'feedback',
      method: "POST",
      content: "JSON",
      body: {
        feedback: this.state.feedback,
        id: this.state.edition.id,
      },
    });

    let api_error = false;
    if(responseJson) {
      if(responseJson.status === "failure"){
        api_error = true
      }
      this.setState({
        api_response: responseJson.message,
        api_error: api_error
      })
    }
  }

  render() {
    return (this.state.edition === null) ? null : (
      <div className="welcome innerBody">
        <Header />

        <div className="container">
          <div className="row mt-5 mb-5">
            <div className="col-lg-6 col-md-12 col-12">
              <h3 className="head_txt pb-3">
                {" "}
                <b> Hurray ! Winner, winner, chicken dinner </b>{" "}
              </h3>
              <p className="pb-3">
                {" "}
                You have successfully completed the {this.state.edition.name} .
                Not many have achieved this feat. You will forever have a place in our coveted Hall of
                fame. It is time to celebrate and do a victory dance. 
              </p>
              <span className="winner_sec">
                {" "}
                <hr size="5" width="300" align="left" />{" "}
              </span>
              <h5 className="pb-3 text-light"> Your rank </h5>

              <h3 className="pb-3">
                {" "}
                <span> {this.state.edition.rank} </span> out of{" "}
                {this.state.edition.puzzlers}{" "}
              </h3>
              <a href="#!" onClick={() => get_current_level(this.state.edition.id)} className="btn btn-yellow ">
                {" "}
                GO BACK TO LEVEL PAGE{" "}
              </a>
            </div>

            <div className="col-lg-6 col-md-12 col-12 text-center topsec">
              <img src={winner} alt="winner" />
            </div>
          </div>
        </div>

        <div className="container-fluid bg-base mt-4">
          <div className="container">
            <div className="row">
              <div className="col pl-0 pr-0">
                <div className="card card-body border-0 o-hidden mb-0 text-light">
                  <div className="position-relative flex-column flex-md-row align-items-center signup_now">
                    <div className="h3 text-center mb-md-0">
                      <span>
                        {" "}
                        <b> Bring your Friends to challenges.</b>{" "}
                      </span>{" "}
                      Start inviting your friends and play together &nbsp;
                      &nbsp; &nbsp;
                      <a
                        href="/invite-friends"
                        className="btn btn-lg btn-yellow ml-2 mt-2 mb-2 invite_btn"
                      >
                        INVITE NOW
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row bg_dark feed_back_box mt-5 mb-5">
            <div className="col-md-2 col-12 text-center mb-4 mt-4">
              <img src={feed_backimg_left} alt="" />
            </div>

            <div className="col-md-8 col-12 text-center feedback_form mb-4 mt-4">
              <h3> Did you like our levels ? </h3>
              <p> Please give your feedback below </p>
              <input
                id="feedback"
                name="feedback"
                type="text"
                placeholder="Accolades and Brickbats"
                onChange={this.handle_change} 
                value={this.state.feedback}
              />
              <button type="button" 
              onClick={this.onSubmit}  
              
              className="btn btn-yellow ">
                {" "}
                SUBMIT{" "}
              </button>
              <div className="wrong_txt mt-4 text-center">
                {
                  this.state.api_error && (
                    <p>
                      {this.state.api_response}
                    </p>
                  )
                }
              </div>
              <div className="success_txt mt-4 text-center">
                {
                  !this.state.api_error && (
                    <p>
                      {this.state.api_response}
                    </p>
                  )
                }
              </div>
            </div>

            <div className="col-md-2 col-12 text-center mb-4 mt-4">
              <img src={feed_backimg_right} alt="" />
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row mt-5 mb-3 rating">
            <div className="col-12">
              {" "}
              <h4 className="text-light" style={{fontSize:"21px",letterSpacing:"1px"}}>
                {" "}
                <b>
                  {" "}
                  Rate and help us to make Puzzled more awesome{" "}
                </b> <br />{" "}
                {/* <span> Rate each Level to give us an idea of your experience </span>{" "} */}
              </h4>{" "}
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row rating d-flex mb-2">
            {this.state.edition.levels &&
              this.state.edition.levels.map((level) => (
                <LevelFeedback
                  key={level.id}
                  id={level.id}
                  number={level.number}
                  notes={level.notes}
                  image={level.image}
                  rating={level.rating}
                />
              ))}
          </div>
        </div>

        

        <Footer />
      </div>
    );
  }
}

export default Winner;
